import React, {useState, useRef, useEffect} from 'react';
import UserListItemMessage from "./UserListItemMessage.mjs";
import TeamInvitationListItem from './TeamInvitationListItem.mjs';
//import './TeamInvitationsCard.css';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function TeamInvitationsList({team_id}) 
{
    const { team_invitations_list } = useCTAL();

    if ((!team_invitations_list) || (team_invitations_list.length == 0)) return;

    if (DEBUG) return;

    return (
        <>
            <ol class="list-group">
                <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-start">
                    <div class="ms-1 me-auto">
                        Team Invitations ({team_invitations_list.length})
                    </div>
                </li>
                { team_invitations_list?.map( (member, i) => ( <TeamInvitationListItem member={member} key={i} ndx={i}/> )) }
            </ol>
        </>
    );
}

/*
    const [team_invitations_list, setTeamInvitationsList] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");

    useEffect(() =>
    {
        if (!team_id) return;
        
        if (fetchRef.id == team_id) return;
        fetchRef.id = team_id;
  
        var type = "get_team_invitations";
        var search_body = JSON.stringify({type, team_id});

        console.log(`TeamInvitationsList - fetching Team Invitations List from ctal-get for: ${team_id}`);
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(setTeamInvitationsList)
            .then(() => setLoading(false))
            .catch(setError);
    }, [team_id]);

    if (loading) return <UserListItemMessage message="Loading Team Invitations List..." />;
    if (error) return <UserListItemMessage message={JSON.stringify(error, null, 2)} /> 
*/
